import * as React from "react";
import {
	Box,
	Card,
	CardContent,
	Typography,
	CardActions,
	Button,
	IconButton,
} from "@mui/material";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import { CustomModal } from "../../components/Modal/CustomModal";
import { ContractorDetails } from "../../components/Detail/contractor/ContractorDetails";
import { ProjectDetails } from "../../components/Detail/project/ProjectDetails";
import { MdaDetails } from "../../components/Detail/mda/MDADetails";
import { HtmlTooltip as Tooltip } from "../../components/Tooltip";

export const CardArea = () => {
	const [isFirstProject, setIsFirstProject] = React.useState<boolean>(false);
	const [isSecondProject, setIsSecondProject] = React.useState<boolean>(false);
	const [isThirdProject, setIsThirdProject] = React.useState<boolean>(false);
	const [isFirstCbyNum, setIsFirstCbyNum] = React.useState<boolean>(false);
	const [isSecondCbyNum, setIsSecondCbyNum] = React.useState<boolean>(false);
	const [isThirdCbyNum, setIsThirdCbyNum] = React.useState<boolean>(false);
	const [isFirstCbyMda, setIsFirstCbyMda] = React.useState<boolean>(false);
	const [isSecondCbyMda, setIsSecondCbyMda] = React.useState<boolean>(false);
	const [isThirdCbyMda, setIsThirdCbyMda] = React.useState<boolean>(false);

	const openFirstProjectDetailHandler = () => {
		setIsFirstProject(!isFirstProject);
	};
	const openSecondProjectDetailHandler = () => {
		setIsSecondProject(!isSecondProject);
	};
	const openThirdProjectDetailHandler = () => {
		setIsThirdProject(!isThirdProject);
	};
	const openFirstCbyNumHandler = () => {
		setIsFirstCbyNum(!isFirstCbyNum);
	};
	const openSecondCbyNumHandler = () => {
		setIsSecondCbyNum(!isSecondCbyNum);
	};
	const openThirdCbyNumHandler = () => {
		setIsThirdCbyNum(!isThirdCbyNum);
	};
	const openFirstCbyMdaHandler = () => {
		setIsFirstCbyMda(!isFirstCbyMda);
	};
	const openSecondCbyMdaHandler = () => {
		setIsSecondCbyMda(!isSecondCbyMda);
	};
	const openThirdCbyMdaHandler = () => {
		setIsThirdCbyMda(!isThirdCbyMda);
	};

	return (
		<Box
			sx={{
				width: "100%",
				backgroundColor: "#F7FAFC",
				border: "1px solid #F7FAFC",
			}}
		>
			<Box className="home__card__wrapper">
				<Box>
					<Box
						sx={{
							fontWeight: "700",
							fontSize: "28.0018px",
							lineHeight: "42px",
							color: "#09797A",
							paddingLeft: "5%",
							paddingTop: "40px",
						}}
					>
						<h2>Data Highlights</h2>
					</Box>
					<Box className="home__card__area">
						<Box className="home__card__container">
							<Box className="home__card__item">
								<Card
									sx={{
										borderRadius: "20px",
										height: "320px",
										position: "relative",
									}}
								>
									<CardActions sx={{ padding: "10%" }}>
										<Tooltip
											title={
												<React.Fragment>
													<em>{"Click on the "}</em>
													<b>{"Grey Buttons"}</b> <br />
													<em>{"to view info"}</em>
												</React.Fragment>
											}
										>
											<IconButton
												aria-label="info"
												component="label"
												sx={{
													position: "absolute",
													top: "20px",
													left: "20px",
													width: "24px",
													height: "24px",
													color: "#3ED9C4",
													textTransform: "capitalize",
													fontWeight: "600",
													fontSize: "13.5992px",
													lineHeight: "20px",
													boxShadow: "0px 4px 11px rgba(0, 0, 0, 0.07)",
													borderRadius: "50%",
												}}
											>
												<HelpOutlineIcon />
											</IconButton>
										</Tooltip>
									</CardActions>
									<CardContent sx={{ position: "relative" }}>
										<Typography
											sx={{
												fontWeight: "600",
												fontSize: "14px",
												lineHeight: "18px",
												color: "#09797A",
											}}
											gutterBottom
										>
											Top 3 project where contract amount exceed budget amount
										</Typography>
										<Box
											sx={{
												width: "90%",
												maxWidth: 360,
												borderRadius: "4px",
												margin: "auto",
												position: "absolute",
												top: "80%",
											}}
										>
											<Box
												className="home__card__item__list"
												onClick={openFirstProjectDetailHandler}
											>
												<Box>Contract for the construction of Mubi Bypass</Box>
												<Box className="home__card__data__highlight">85%</Box>
											</Box>
											<CustomModal
												isOpen={isFirstProject}
												toggleModal={openFirstProjectDetailHandler}
												headerText="Project Details"
												modalContent={
													<ProjectDetails title="Contract for the construction of Mubi Bypass" />
												}
											/>
											<Box
												className="home__card__item__list"
												onClick={openSecondProjectDetailHandler}
											>
												<Box>Construction of Mbamba Street</Box>
												<Box className="home__card__data__highlight">77%</Box>
											</Box>
											<CustomModal
												isOpen={isSecondProject}
												toggleModal={openSecondProjectDetailHandler}
												headerText="Project Details"
												modalContent={
													<ProjectDetails title="Contract for the construction of Mbamba Street" />
												}
											/>
											<Box
												className="home__card__item__list"
												onClick={openThirdProjectDetailHandler}
											>
												<Box>Construction of Mafia Road with fall out drain</Box>
												<Box className="home__card__data__highlight">66%</Box>
											</Box>
											<CustomModal
												isOpen={isThirdProject}
												toggleModal={openThirdProjectDetailHandler}
												headerText="Project Details"
												modalContent={
													<ProjectDetails title="Contract for the construction of Mafia Road with fall out drain" />
												}
											/>
										</Box>
									</CardContent>
									<CardActions sx={{ position: "absolute", bottom: "0", right: "0" }}>
										<Button
											size="small"
											sx={{
												color: "#3ED9C4",
												textTransform: "capitalize",
												fontWeight: "600",
												fontSize: "13.5992px",
												lineHeight: "20px",
											}}
										>
											Find More <KeyboardArrowRightIcon />
										</Button>
									</CardActions>
								</Card>
							</Box>
							<Box>
								<Card
									sx={{ borderRadius: "20px", height: "320px", position: "relative" }}
								>
									<CardActions sx={{ padding: "10%" }}>
										<Tooltip
											title={
												<React.Fragment>
													<em>{"Click on the "}</em>
													<b>{"Grey Buttons"}</b> <br />
													<em>{"to view info"}</em>
												</React.Fragment>
											}
										>
											<IconButton
												aria-label="info"
												component="label"
												sx={{
													position: "absolute",
													top: "20px",
													left: "20px",
													width: "24px",
													height: "24px",
													color: "#3ED9C4",
													textTransform: "capitalize",
													fontWeight: "600",
													fontSize: "13.5992px",
													lineHeight: "20px",
													boxShadow: "0px 4px 11px rgba(0, 0, 0, 0.07)",
													borderRadius: "50%",
												}}
											>
												<HelpOutlineIcon />
											</IconButton>
										</Tooltip>
									</CardActions>
									<CardContent sx={{ position: "relative" }}>
										<Typography
											sx={{
												fontWeight: "600",
												fontSize: "14px",
												lineHeight: "18px",
												color: "#09797A",
											}}
											gutterBottom
										>
											Top 3 contractors by number of projects
										</Typography>
										<Box
											sx={{
												width: "90%",
												maxWidth: 360,
												borderRadius: "4px",
												margin: "auto",
												position: "absolute",
												top: "80%",
											}}
										>
											<Box
												className="home__card__item__list"
												onClick={openFirstCbyNumHandler}
											>
												<Box>Samparaco Nig Ltd</Box>
												<Box className="home__card__data__highlight">11</Box>
											</Box>
											<CustomModal
												isOpen={isFirstCbyNum}
												toggleModal={openFirstCbyNumHandler}
												headerText="Contractor Details"
												modalContent={<ContractorDetails title="Samparaco Nig Ltd" />}
											/>
											<Box
												className="home__card__item__list"
												onClick={openSecondCbyNumHandler}
											>
												<Box>Birding International Ltd</Box>
												<Box className="home__card__data__highlight">8</Box>
											</Box>
											<CustomModal
												isOpen={isSecondCbyNum}
												toggleModal={openSecondCbyNumHandler}
												headerText="Contractor Details"
												modalContent={
													<ContractorDetails title="Birding International Ltd" />
												}
											/>
											<Box
												className="home__card__item__list"
												onClick={openThirdCbyNumHandler}
											>
												<Box>Jaigooni Engineering Ltd</Box>
												<Box className="home__card__data__highlight">3</Box>
											</Box>
											<CustomModal
												isOpen={isThirdCbyNum}
												toggleModal={openThirdCbyNumHandler}
												headerText="Contractor Details"
												modalContent={
													<ContractorDetails title="Jaigooni Engineering Ltd" />
												}
											/>
										</Box>
									</CardContent>
									<CardActions sx={{ position: "absolute", bottom: "0", right: "0" }}>
										<Button
											size="small"
											sx={{
												color: "#3ED9C4",
												textTransform: "capitalize",
												fontWeight: "600",
												fontSize: "13.5992px",
												lineHeight: "20px",
											}}
										>
											Find More <KeyboardArrowRightIcon />
										</Button>
									</CardActions>
								</Card>
							</Box>
							<Box>
								<Card
									sx={{ borderRadius: "20px", height: "320px", position: "relative" }}
								>
									<CardActions sx={{ padding: "10%" }}>
										<Tooltip
											title={
												<React.Fragment>
													<em>{"Click on the "}</em>
													<b>{"Grey Buttons"}</b> <br />
													<em>{"to view info"}</em>
												</React.Fragment>
											}
										>
											<IconButton
												aria-label="info"
												component="label"
												sx={{
													position: "absolute",
													top: "20px",
													left: "20px",
													width: "24px",
													height: "24px",
													color: "#3ED9C4",
													textTransform: "capitalize",
													fontWeight: "600",
													fontSize: "13.5992px",
													lineHeight: "20px",
													boxShadow: "0px 4px 11px rgba(0, 0, 0, 0.07)",
													borderRadius: "50%",
												}}
											>
												<HelpOutlineIcon />
											</IconButton>
										</Tooltip>
									</CardActions>
									<CardContent sx={{ position: "relative" }}>
										<Typography
											sx={{
												fontWeight: "600",
												fontSize: "14px",
												lineHeight: "18px",
												color: "#09797A",
											}}
											gutterBottom
										>
											Top 3 contractors by diversity of MDAs
										</Typography>
										<Box
											sx={{
												width: "90%",
												maxWidth: 360,
												borderRadius: "4px",
												margin: "auto",
												position: "absolute",
												top: "95%",
											}}
										>
											<Box
												className="home__card__item__list"
												onClick={openFirstCbyMdaHandler}
											>
												<Box>Birding International Ltd</Box>
												<Box className="home__card__data__highlight">3</Box>
											</Box>
											<CustomModal
												isOpen={isFirstCbyMda}
												toggleModal={openFirstCbyMdaHandler}
												headerText="Contractor Project Across MDAs"
												modalContent={<MdaDetails title="Birding International Ltd" />}
											/>
											<Box
												className="home__card__item__list"
												onClick={openSecondCbyMdaHandler}
											>
												<Box>Gongola Confluence Construction Ltd</Box>
												<Box className="home__card__data__highlight">3</Box>
											</Box>
											<CustomModal
												isOpen={isSecondCbyMda}
												toggleModal={openSecondCbyMdaHandler}
												headerText="Contractor Project Across MDAs"
												modalContent={
													<MdaDetails title="Gongola Confluence Construction Ltd" />
												}
											/>
											<Box
												className="home__card__item__list"
												onClick={openThirdCbyMdaHandler}
											>
												<Box>DE ID Vision Nig. Ent</Box>
												<Box className="home__card__data__highlight">2</Box>
											</Box>
											<CustomModal
												isOpen={isThirdCbyMda}
												toggleModal={openThirdCbyMdaHandler}
												headerText="Contractor Project Across MDAs"
												modalContent={<MdaDetails title="DE ID Vision Nig. Ent" />}
											/>
										</Box>
									</CardContent>

									<CardActions sx={{ position: "absolute", bottom: "0", right: "0" }}>
										<Button
											size="small"
											sx={{
												color: "#3ED9C4",
												textTransform: "capitalize",
												fontWeight: "600",
												fontSize: "13.5992px",
												lineHeight: "20px",
											}}
										>
											Find More <KeyboardArrowRightIcon />
										</Button>
									</CardActions>
								</Card>
							</Box>
							<Box>
								<Card
									sx={{ borderRadius: "20px", height: "320px", position: "relative" }}
								>
									<CardActions sx={{ padding: "10%" }}>
										<Tooltip
											title={
												<React.Fragment>
													<em>{"Click on the "}</em>
													<b>{"Grey Buttons"}</b> <br />
													<em>{"to view info"}</em>
												</React.Fragment>
											}
										>
											<IconButton
												aria-label="info"
												component="label"
												sx={{
													position: "absolute",
													top: "20px",
													left: "20px",
													width: "24px",
													height: "24px",
													color: "#3ED9C4",
													textTransform: "capitalize",
													fontWeight: "600",
													fontSize: "13.5992px",
													lineHeight: "20px",
													boxShadow: "0px 4px 11px rgba(0, 0, 0, 0.07)",
													borderRadius: "50%",
												}}
											>
												<HelpOutlineIcon />
											</IconButton>
										</Tooltip>
									</CardActions>
									<CardContent sx={{ position: "relative" }}>
										<Typography
											sx={{
												fontWeight: "600",
												fontSize: "14px",
												lineHeight: "18px",
												color: "#09797A",
											}}
											gutterBottom
										>
											Number of projects with missing data
										</Typography>
										<Box
											sx={{
												width: "90%",
												maxWidth: 360,
												borderRadius: "4px",
												margin: "auto",
												position: "absolute",
												top: "95%",
											}}
										>
											<Box className="home__card__item__list">
												<Box>Missing budget amount</Box>
												<Box className="home__card__data__highlight">19</Box>
											</Box>
											<Box className="home__card__item__list">
												<Box>Missing contract amount</Box>
												<Box className="home__card__data__highlight">1</Box>
											</Box>
											<Box className="home__card__item__list">
												<Box>Missing location</Box>
												<Box className="home__card__data__highlight">60</Box>
											</Box>
										</Box>
									</CardContent>

									<CardActions sx={{ position: "absolute", bottom: "0", right: "0" }}>
										<Button
											size="small"
											sx={{
												color: "#3ED9C4",
												textTransform: "capitalize",
												fontWeight: "600",
												fontSize: "13.5992px",
												lineHeight: "20px",
											}}
										>
											Find More <KeyboardArrowRightIcon />
										</Button>
									</CardActions>
								</Card>
							</Box>
						</Box>
					</Box>
				</Box>
			</Box>
		</Box>
	);
};
